 <div class="main-content bg-white pt-3">
    <!-- <h4>
      <span class="title-tabs mb-0 fs-4">About Us</span>
    </h4> -->
    <div class="contact-container text-center">
      <div class="row justify-content-center">
        <div class="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
            <section id="about-content">
              <div class="card about-card border-0">
                <div class="card-body bg-transparent text-center">
                  <h1>About Us</h1>
                  <p class="my-3">TILA Top Up</p>
                  <p>
                    "Tila Top Up is a user-friendly system that offers Pinless services for International Long Distance, Domestic and International Top Ups. Tila acts as the intermediary between you and your carrier. Tila also offers you International Long Distance at lower rates with the best quality. Tila offers over 200 carriers worldwide. </p>
                    <br/><p>Tila ensures safe and secure transactions verified within seconds with a confirmation text. With Tila Rewards, earn points every time you use Tila. With over 25 years of experience, Tila ensures that you stay connected with your loved ones using the best quality and low cost. You are our priority!"
                  </p>
                </div>
              </div>
              </section>
        </div>
    </div>
    </div>
</div>




